import { useContext, useEffect, useRef, useState } from "react";
import styles from "./InteractionContainer.module.scss";
import clapImg from "../../../../assets/images/icons/clap.png";
import thinkImg from "../../../../assets/images/icons/think.png";
import thoughtImg from "../../../../assets/images/icons/thought.png";
import InteractionIcon from "./patials/InteractionIcon/InteractionIcon";
import InteractionPeople from "./patials/InteractionPeople/InteractionPeople";
import clapLottie from "../../../../assets/lotties/liveReaction/clap.json";
import curiousLottie from "../../../../assets/lotties/liveReaction/curious.json";
import insightfulLottie from "../../../../assets/lotties/liveReaction/insightful.json";
import { UserContext } from "../../../../contexts/UserContext/UserContextProvider";
import { AnalyticsContext } from "../../../../contexts/Analytics/AnalyticsContextProvider";
import LiveReactionManager from "../../../../Managers/webinar/liveReaction";
import {
  LIVE_INTERACTION_CURIOUS_CLICK,
  LIVE_INTERACTION_AMAZING_CLICK,
  LIVE_INTERACTION_THINKING_CLICK,
} from "../../../../AppConstants/AnalyticsEventName";
import { LIVE_REACTION_EVENT } from "../../../../Clevertap/EventNames.ts";
import { getAgendaData } from "../../../../Clevertap/EventHandler.ts";
import { globalsAPI } from "../../../../apis/globalsAPI.js";
import { filterNullObjectKeys } from "../../../../utils/common.utils.js";
import { STORAGE_BASE_URL } from "../../../../AppConstants/Constants.js";
import firebase from "../../../../firebase/firebase";
import { isEmpty } from "lodash";
import moment from "moment";

export const EMOJI_NAMES = {
  CURIOUS: "curious",
  AMAZING: "amazing",
  THINKING: "thinking",
};
const dummyImages = [
  `${STORAGE_BASE_URL}dummyAssets/interactedMale.png`,
  `${STORAGE_BASE_URL}dummyAssets/intereactedFemale.png`,
];

const InteractionContainer = ({ agenda, eventDetails }) => {
    const dummyEmojiData = {
        [EMOJI_NAMES.CURIOUS]: {
          enable: true,
          lottie: insightfulLottie,
          icon: thoughtImg,
          name: EMOJI_NAMES.CURIOUS,
          selectedColor: "#f5bb5c",
          count: 0,
        },
        [EMOJI_NAMES.AMAZING]: {
          enable: true,
          lottie: clapLottie,
          icon: clapImg,
          name: EMOJI_NAMES.AMAZING,
          selectedColor: "#6dae4d",
          count: 0,
        },
        [EMOJI_NAMES.THINKING]: {
          enable: true,
          lottie: curiousLottie,
          icon: thinkImg,
          name: EMOJI_NAMES.THINKING,
          selectedColor: "#deb8dc",
          count: 0,
        },
      };
      
  const { userBasicDetails } = useContext(UserContext);
  const debounceRef = useRef(null);
  const { addGAWithUserInfo, addCleverTapAnalytics } =
    useContext(AnalyticsContext);
  const [interactionPeople, setInteractionPeople] = useState({
    users: [],
    filteredUsers: [],
  });
  const [emojiData, setEmojiData] = useState(dummyEmojiData);

  useEffect(() => {
    getLiveReaction();
    return () => {
      LiveReactionManager._get.removeLiveReactionListener();
    };
  }, []);

  const getLiveReaction = () => {
    LiveReactionManager._get.attachLiveReactionListener(
      eventDetails.id,
      (data, err) => {
        if (err) {
          return;
        }
        if (data) {
          setEmojiData((prev) => {
            let obj = prev;
            Object.keys(EMOJI_NAMES).forEach((key) => {
              obj[EMOJI_NAMES[key]].count = data[EMOJI_NAMES[key]] || 0;
            });
            return obj;
          });

          const validUserData = data.users?.reduce((acc, user) => {
            const currentTime = firebase.firestore.Timestamp.now();
            const currentMoment = moment(currentTime.toDate());
            const userMoment = moment(user.timestamp);
            const difference = Math.abs(
              currentMoment.diff(userMoment, "milliseconds")
            );
            if (difference <= 10000) {
              // 10 seconds in milliseconds
              // `${user.type}_${user.userId}`
              acc[`${user.timestamp}`] = user;
            }
            return acc;
          }, {});
          setInteractionPeople((prev) => {
            return {
              ...prev,
              ...data,
              filteredUsers: { ...prev?.filteredUsers, ...validUserData },
            };
          });
        }
      }
    );
  };

  const timeOut = () => {
    if (!debounceRef.current) {
      let timeRun = 0;
      const TIME = 2;
      debounceRef.current = setInterval(() => {
        timeRun++;
        if (timeRun === TIME) {
          clearInterval(debounceRef.current);
          debounceRef.current = null;
        }
      }, 1000);
    }
  };

  const handleEmojiClick = (name) => {
    if (debounceRef.current) return;

    let rndInt = Math.floor(Math.random() * 2) + 1;

    let obj = {
      webinarId: eventDetails.id,
      agendaId: eventDetails.ongoingagendaid || "",
      profileImg: dummyImages[rndInt - 1],
      name: `${userBasicDetails?.firstName} ${userBasicDetails?.lastName}`,
    };

    let eventName = "";

    switch (name) {
      case EMOJI_NAMES.CURIOUS:
        obj.type = EMOJI_NAMES.CURIOUS;
        eventName = LIVE_INTERACTION_CURIOUS_CLICK;
        break;
      case EMOJI_NAMES.AMAZING:
        obj.type = EMOJI_NAMES.AMAZING;
        eventName = LIVE_INTERACTION_AMAZING_CLICK;
        break;
      case EMOJI_NAMES.THINKING:
        obj.type = EMOJI_NAMES.THINKING;
        eventName = LIVE_INTERACTION_THINKING_CLICK;
        break;
      default:
        return;
    }
    addClickAnalytics(eventName);
    let agendaDetails = agenda.mainData.filter(
      (d) => d.id === eventDetails.ongoingagendaid
    )[0];
    addCleverTapAnalytics(LIVE_REACTION_EVENT, {
      Content: obj.type,
      ...getAgendaData({
        ...agendaDetails,
        "Webinar Title": eventDetails.title,
      }),
    });
    globalsAPI
      .addLiveReaction(filterNullObjectKeys(obj))
      .then((res) => {
        // console.log("response", res);
      })
      .catch((err) => {
        console.error(err);
      });
    timeOut();
  };

  const handleTimeUp = (time, id) => {
    // let obj = {
    //   webinarId: eventDetails.id,
    // };
    // globalsAPI
    //   .popLiveReaction(obj)
    //   .then((res) => {
    //     console.log("response", res);
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //   });

    clearInterval(time);
    setInteractionPeople((prev) => {
      let _prev = { ...prev };
      delete _prev["filteredUsers"]?.[id];
      return _prev;
    });
  };
  const addClickAnalytics = (eventName) => {
    addGAWithUserInfo(eventName, {
      eventId: eventDetails.id,
      agendaId: eventDetails.ongoingagendaid || null,
    });
  };
  return (
    <>
      <div className={styles.containerBottom}>
        <div className={styles.interactionContainer}>
          {Object.keys(emojiData).map(
            (key) =>
              emojiData[key].enable && (
                <InteractionIcon
                  key={key}
                  item={emojiData[key]}
                  handleEmoji={handleEmojiClick}
                />
              )
          )}
        </div>
      </div>
      <div className={styles.containerRight}>
        {!isEmpty(interactionPeople.filteredUsers) && (
          <div className={styles.interactedPeople}>
            {Object.keys(interactionPeople.filteredUsers).map((key, index) => (
              <InteractionPeople
                id={key}
                key={index}
                item={interactionPeople.filteredUsers[key]}
                timeUp={handleTimeUp}
                webinarId={eventDetails.id}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default InteractionContainer;
